import axios from "axios";
import {
  CONNECTIQ_CHAT_ROUTE,
  CONNECTIQ_GET_SESSIONS_ROUTE,
  CONNECTIQ_GET_MESSAGES_ROUTE,
  CONNECTIQ_DELETE_SESSION_ROUTE,
  CONNECTIQ_PROFILE_CHAT_ROUTE,
  CONNECTIQ_PROFILE_HISTORY_ROUTE,
  CONNECTIQ_PROFILE_SESSIONS_ROUTE,
  CONNECTIQ_CREATE_PROFILE_SESSION_ROUTE,
  CONNECTIQ_GET_FIRM_USAGE_ROUTE,
} from "./apiRoutes";

// Send a message and get AI response
export const connectiqChat = (userSlug, message, scope, sessionId) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("message", message);
  postData.append("scope", scope);
  if (sessionId) postData.append("session_id", sessionId);
  return axios.post(CONNECTIQ_CHAT_ROUTE, postData).catch(() => false);
};

// Get all sessions for sidebar history
export const connectiqGetSessions = (userSlug) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  return axios.post(CONNECTIQ_GET_SESSIONS_ROUTE, postData).catch(() => false);
};

// Get all messages for a session
export const connectiqGetMessages = (userSlug, sessionId) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("session_id", sessionId);
  return axios.post(CONNECTIQ_GET_MESSAGES_ROUTE, postData).catch(() => false);
};

// Delete a session
export const connectiqDeleteSession = (userSlug, sessionId) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("session_id", sessionId);
  return axios
    .post(
      CONNECTIQ_DELETE_SESSION_ROUTE,
      CONNECTIQ_PROFILE_CHAT_ROUTE,
      postData,
    )
    .catch(() => false);
};

// Get firm usage summary for dashboard widget
export const connectiqGetFirmUsage = (userSlug, range = "30") => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("range", range);
  return axios
    .post(CONNECTIQ_GET_FIRM_USAGE_ROUTE, postData)
    .catch(() => false);
};
export const connectiqGetProfileSessions = (userSlug, resourceSlug) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("resource_slug", resourceSlug);
  return axios
    .post(CONNECTIQ_PROFILE_SESSIONS_ROUTE, postData)
    .catch(() => false);
};

// Load messages for a specific profile session
export const connectiqGetProfileHistory = (userSlug, sessionId) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("session_id", sessionId);
  return axios
    .post(CONNECTIQ_PROFILE_HISTORY_ROUTE, postData)
    .catch(() => false);
};

// Create a new profile session
export const connectiqCreateProfileSession = (
  userSlug,
  resourceSlug,
  candidateName,
) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("resource_slug", resourceSlug);
  postData.append("candidate_name", candidateName);
  return axios
    .post(CONNECTIQ_CREATE_PROFILE_SESSION_ROUTE, postData)
    .catch(() => false);
};

// Profile-specific chat — single candidate analysis on the profile page
export const connectiqProfileChat = (
  userSlug,
  message,
  profileText,
  resourceSlug,
  candidateName,
  sessionId,
  queryType = "general",
) => {
  const postData = new FormData();
  postData.append("user_slug", userSlug);
  postData.append("message", message);
  postData.append("profile_text", profileText);
  postData.append("resource_slug", resourceSlug);
  postData.append("candidate_name", candidateName);
  postData.append("session_id", sessionId || "");
  postData.append("query_type", queryType);
  return axios.post(CONNECTIQ_PROFILE_CHAT_ROUTE, postData).catch(() => false);
};
